"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var api_1 = require("../../../api");
var Icon_1 = require("../../Common/Icon/Icon");
var DpModal_1 = require("../Modal/DpModal");
var DataTableModal_styled_1 = require("./DataTableModal.styled");
var Spinner_1 = require("../Spinner/Spinner");
var DataTableModal = function (_a) {
    var show = _a.show, closeHandler = _a.closeHandler, title = _a.title, tableData = _a.tableData, headers = _a.headers;
    // ------------------------------- State
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var _c = (0, react_1.useState)(tableData), data = _c[0], setData = _c[1];
    var _d = (0, react_1.useState)({
        direction: api_1.SortDirectionEnumerables.ascending,
        property: 'name',
    }), sortingCriteria = _d[0], setSortingCriteria = _d[1];
    // iteratively get the value of nested objects using object and key.
    var getValue = function (row, keyString) {
        if (!keyString)
            return row;
        var key;
        var keys = keyString.split('.');
        var i;
        for (i = 0; i < keys.length - 1; i++) {
            key = keys[i];
            var value = row[key];
            if (value !== undefined) {
                row = value;
            }
            else {
                break;
            }
        }
        return row[keys[i]];
    };
    // Event called when sorting icon is clicked.
    var sortingCriteriaClicked = function (property, id) { return function () {
        var criteria;
        var sortDirection = api_1.SortDirectionEnumerables.ascending;
        // Define the direction
        if (sortingCriteria.property !== property)
            sortDirection = api_1.SortDirectionEnumerables.ascending;
        else {
            sortDirection =
                sortingCriteria.direction === api_1.SortDirectionEnumerables.ascending
                    ? api_1.SortDirectionEnumerables.descending
                    : api_1.SortDirectionEnumerables.ascending;
        }
        // Set values for new criteria
        if (!sortingCriteria) {
            // default value
            criteria = {
                property: 'name',
                direction: api_1.SortDirectionEnumerables.ascending,
            };
        }
        else {
            criteria = {
                property: property,
                direction: sortDirection,
            };
        }
        document.getElementById(id).setAttribute('aria-label', getAriaLable(property));
        sortingCriteriaChanged(criteria);
    }; };
    // sorting criteria changed event
    var sortingCriteriaChanged = (0, react_1.useCallback)(function (criteria) {
        setSortingCriteria(criteria);
        var copyArray = __spreadArray([], data, true);
        copyArray.sort((0, api_1.sortByCriteria)(criteria));
        setData(copyArray);
    }, [data]);
    // returns icon name
    var iconName = function (property) {
        return (sortingCriteria === null || sortingCriteria === void 0 ? void 0 : sortingCriteria.property) === property
            ? (sortingCriteria === null || sortingCriteria === void 0 ? void 0 : sortingCriteria.direction) === api_1.SortDirectionEnumerables.ascending
                ? 'arrow-up'
                : 'arrow-down'
            : 'up-down';
    };
    // render icon function
    var renderIcon = function (property, id) { return ((0, jsx_runtime_1.jsx)("span", { "aria-live": "polite", className: "padding-button", children: (0, jsx_runtime_1.jsx)("span", { tabIndex: 0, children: (0, jsx_runtime_1.jsx)("span", { "aria-label": getAriaLable(property), role: "button", onKeyDown: (0, api_1.handleButtonPress)(sortingCriteriaClicked(property, id)), onClick: sortingCriteriaClicked(property, id), className: "sorting-column", id: id, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: iconName(property) }) }) }) })); };
    // returns aria label based on property
    var getAriaLable = function (property) {
        var iconValue = iconName(property);
        return iconValue === 'arrow-up'
            ? t('dataTableModal.ariaLabel.sorting', { order: api_1.SortDirectionEnumerables.ascending })
            : iconValue === 'arrow-down'
                ? t('dataTableModal.ariaLabel.sorting', { order: api_1.SortDirectionEnumerables.descending })
                : t('dataTableModal.ariaLabel.clickToSort');
    };
    // ----------------------------------------- Methods
    (0, api_1.useMount)(function () {
        setInitialized(true);
    });
    (0, react_1.useEffect)(function () { return setData(tableData); }, [tableData]);
    return ((0, jsx_runtime_1.jsxs)(DataTableModal_styled_1.StyledModal, { show: show, onHide: closeHandler, size: "xl", scrollable: true, "aria-labelledby": "data-table-modal-title", children: [(0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Header, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("h1", { id: "data-table-modal-title", children: title }) }) }), (0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Body, { children: initialized ? ((0, jsx_runtime_1.jsx)("div", { className: "data-table-modal", children: (0, jsx_runtime_1.jsx)("div", { className: "report", children: (0, jsx_runtime_1.jsxs)("table", { "aria-labelledby": "data-table-modal-title", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: headers.map(function (row, index) {
                                            var component;
                                            if (row.sortable) {
                                                component = ((0, jsx_runtime_1.jsxs)("th", { className: row.headerName, scope: "col", children: [row.headerName, renderIcon(row.key, row.headerName)] }, index));
                                            }
                                            else {
                                                component = ((0, jsx_runtime_1.jsx)("th", { className: row.headerName, scope: "col", children: (0, jsx_runtime_1.jsx)("span", { className: "", children: row.headerName }) }, index));
                                            }
                                            return component;
                                        }) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: data.map(function (row, index) { return ((0, jsx_runtime_1.jsx)("tr", { className: "", children: headers.map(function (header, headerIndex) { return ((0, jsx_runtime_1.jsx)("td", { className: "", children: getValue(row, header.key) }, headerIndex)); }) }, index)); }) })] }) }) })) : ((0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { className: "spinner", ariaLabel: t('dataTableModal.fetchingInformation') })) })] }));
};
exports.DataTableModal = DataTableModal;
exports.default = exports.DataTableModal;
